
import axios from 'axios';
import { API_KEY, BASE_URL, getAxiosConfig } from '../../components/interface/Config';
import { apiHandler } from '../authService';

const API_URL = `${BASE_URL}/resource/patientHistories`; // Update the endpoint for medical history as needed

// Fetch medical history for a patient
export const fetchMedicalHistory = async (token: string, params: Record<string, any>) => {
    try {
        const response = await axios.get<{ data: {patient_histories: any[], pagination: { total: number ,per_page:number, current_page:number, last_page:number} } }>(API_URL, {
            params,
            headers: getAxiosConfig().headers,
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch medical history.');
    }
};

// Delete a specific medical history entry by ID
export const deleteMedicalHistory = async (token: string, historyId: number) => {
    try {

        const url       = `${API_URL}/${historyId}`;
        const response  = await apiHandler(token, 'DELETE',{}, url);

        if (!response) {
            throw new Error("No response received from the server");
        }

        // await axios.delete(`${API_URL}/${historyId}`, {
        //     headers: {
        //         Authorization: `Bearer ${token}`,
        //         'X-API-Key': API_KEY,
        //         'Content-Type': 'application/json',
        //     },
        // });
        return response;
    } catch (error) {
        throw new Error('Error deleting medical history entry.');
    }
};

// Add or update medical history
export const saveMedicalHistory = async (token: string, historyData: Record<string, any>, historyId?: number) => {
    try {
        if (historyId) {
            // Update existing medical history
            const url       = `${API_URL}/${historyId}`;
            await apiHandler(token, 'PUT', historyData, url);

            // await axios.put(`${API_URL}/${historyId}`, historyData, {
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //         'X-API-Key': API_KEY,
            //         'Content-Type': 'application/json',
            //     },
            // });
        } else {
            await apiHandler(token, 'POST', historyData, API_URL);
            
            // Create new medical history
            // await axios.post(API_URL, historyData, {
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //         'X-API-Key': API_KEY,
            //         'Content-Type': 'application/json',
            //     },
            // });
        }
    } catch (error) {
        throw new Error('Error saving medical history.');
    }
};
